import React from "react";
import Growth from "../../shared/Growth";
// components

type IPageVisits = {
  name: string;
  link: string;
  visitors: number;
  uniqueVisitors: number;
  bounceRate: number;
};

type PageVisitsProps = {
  data: Array<IPageVisits>;
  className?: string;
};

const defaultProps = { data: [] };

const TablePageVisits = ({ data, className }: PageVisitsProps): JSX.Element => {
  return (
    <table className="items-center w-full bg-transparent">
      <thead>
        <tr>
          <th className="table-header">Page name</th>
          <th className="table-header">Visitors</th>
          <th className="table-header">Unique users</th>
          <th className="table-header">Bounce rate</th>
        </tr>
      </thead>
      <tbody>
        {data?.map((d, i) => {
          return (
            <tr key={i}>
              <th className="table-data">{d.name}</th>
              <td className="table-data">{d.visitors}</td>
              <td className="table-data">{d.uniqueVisitors}</td>
              <td className="table-data">
                <Growth percentage={d.bounceRate} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

TablePageVisits.defaultProps = defaultProps;

export default TablePageVisits;
